import { Button, Classes, Intent } from '@blueprintjs/core'
import { IconName } from '@blueprintjs/icons'
import React, { ReactNode } from 'react'
import { UprightStyle } from '../../../types'

const styles: UprightStyle = {
  buttonMargin: {
    marginRight: 10
  },
  divCard: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  titleMargin: {
    margin: 0
  },
  textMargin: {
    margin: '6px 0'
  }
}

interface Actions {
  humanReadableName: string
  icon?: IconName
  intent: Intent
  onClick: () => void
}

interface BulkActionBarProps {
  title: string
  actions: Actions[]
}

export const BulkActionBar = ({ title, actions = [] }: BulkActionBarProps): JSX.Element => {
  const renderAction = (action: Actions, i: number): ReactNode => {
    const isLast = i === actions.length - 1
    return (
      <Button
        style={!isLast ? styles.buttonMargin : null}
        icon={action.icon}
        intent={action.intent}
        key={action.humanReadableName}
        onClick={action.onClick}
        minimal={action.humanReadableName.includes('Review') ? false : !isLast}
      >
        {action.humanReadableName}
      </Button>
    )
  }

  return (
    <div style={styles.divCard}>
      <h3 style={styles.titleMargin}>{title}</h3>
      <div>
        {actions.length ? (
          actions.map(renderAction)
        ) : (
          <p className={Classes.TEXT_MUTED} style={styles.textMargin}>
            No bulk actions available
          </p>
        )}
      </div>
    </div>
  )
}
